// The live preview contract. apps/web embeds the mobile app's web build
// (mobile-next `/preview`) in an iframe and drives it over `postMessage`; both
// ends import these. See apps/mobile-next/components/preview/README.md.

/** `source` of the messages the frame sends (`ready`). */
export const PREVIEW_FRAME_SOURCE = "congrs-preview";

/** `source` of the messages the embedding page sends (`init`, `config`). */
export const PREVIEW_HOST_SOURCE = "congrs-preview-host";

/**
 * The screens the frame can show, by the `view` the host names. mobile-next
 * types its screen registry by these keys, so a screen added here fails to
 * typecheck until the frame can render it.
 */
export const PREVIEW_VIEW = /** @type {const} */ ({
  home: "home",
  covers: "covers",
  agenda: "agenda",
});
